<template>
	<div class="hello">
		<header class="header ui-header-positive ui-border-b" style="padding:0 210px">
			<ul class="ui-tiled">
				<div><img src="/static/img/logo.png" /> </div>
				<li id="sbkz">
				<router-link to="/devicemanage" tag="li" >
					<div>设备控制</div>
				</router-link>
				</li>
				<li id="xxjl">
				<router-link to="/msgLog" tag="li">
					<div>消息记录</div>
				</router-link>
				</li>
				<li>
				<router-link to="/send" tag="li">
					<div>指令群发</div>
				</router-link>
				</li>
				<li id="dtwz">
				<router-link to="/baidu" tag="li">
					<div>地图位置</div>
				</router-link>
				</li>
			  <li v-on:click="logOut()">
					<div>退出</div>
				</li>
			</ul>
		</header>
		<div class="alert" v-show="alert1">
			<div class="dialog">
				<div style="text-align:center;color:red;">您没有该权限</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'headlink',
		data() {
			return {
				quanxian: false,
				alert1: false
			}
		},
		methods: {
			showAlert: function() {
				var self = this;
				this.alert1 = true;
				window.setTimeout(function() {
					self.alert1 = false;
				}, 3000);
			},
			logOut: function() {
				const history = window.sessionStorage;
				var uid = history.setItem("user", "");
				this.$router.push("/register");
			}
		},
		mounted: function() {
			var childid = store.get("childid");
			var maps = store.get("dtwz" + childid);
			var control = store.get("sbkz" + childid);
			var msg = store.get("xxjl" + childid);
			
			if(maps == undefined) {
		$("li[id=dtwz]").remove();
		
	}

	if(control == undefined) {
		$("li[id=sbkz]").remove();
	}
	
	if(msg == undefined) {
		$("li[id=xxjl").remove();
	}
		},
		components: {}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/headlink1.vue